(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auragleam-collection-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ag-collection-hero')) {
    customElements.define('ag-collection-hero', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.abortController) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.pauseButton = this.querySelector('[data-pause]');
        this.viewport = this.querySelector('.ag-hero__slides');
        this.status = this.querySelector('[data-status]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.interval = Number(this.dataset.interval) || 7000;
        this.editor = this.dataset.designMode === 'true';
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.paused = !this.autoplay || this.motion.matches || this.editor;
        this.hovering = false;
        this.inViewport = false;
        this.suppressClickUntil = 0;
        this.show(0, false);
        const controls = this.querySelector('[data-controls]');
        if (controls) controls.hidden = this.slides.length < 2;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.manual(this.index - 1), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.manual(this.index + 1), options);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.manual(Number(dot.dataset.dot)), options));
        this.pauseButton?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.sync();
        }, options);
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovering = true;
          this.sync();
        }, options);
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovering = false;
          this.sync();
        }, options);
        this.addEventListener('focusin', (event) => {
          if (this.pauseButton?.contains(event.target)) return;
          this.pause();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          if (event.target.closest('input, textarea, select')) return;
          event.preventDefault();
          const activeSlideHasFocus = this.slides[this.index].contains(document.activeElement);
          const nextIndex = this.index + (event.key === 'ArrowRight' ? 1 : -1);
          this.manual(nextIndex);
          if (activeSlideHasFocus) this.dots[this.index]?.focus();
        }, options);
        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' || !event.isPrimary || event.target.closest('button')) return;
          this.touchStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
          clearTimeout(this.timer);
        }, options);
        this.viewport.addEventListener('pointerup', (event) => {
          if (!this.touchStart || event.pointerId !== this.touchStart.id) return;
          const dx = event.clientX - this.touchStart.x;
          const dy = event.clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) >= 50 && Math.abs(dx) > Math.abs(dy) * 1.3) {
            this.suppressClickUntil = Date.now() + 500;
            this.manual(this.index + (dx < 0 ? 1 : -1));
          } else {
            this.sync();
          }
        }, options);
        this.viewport.addEventListener('pointercancel', () => {
          this.touchStart = null;
          this.sync();
        }, options);
        this.addEventListener('click', (event) => {
          if (Date.now() >= this.suppressClickUntil) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, { ...options, capture: true });
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.pause();
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.manual(index);
        }, options);

        const firstImage = this.slides[0]?.querySelector('img');
        this.ready = !firstImage || firstImage.complete;
        if (!this.ready) {
          const ready = () => { this.ready = true; this.sync(); };
          firstImage.addEventListener('load', ready, { ...options, once: true });
          firstImage.addEventListener('error', ready, { ...options, once: true });
        }
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inViewport = entries[0].isIntersecting;
            this.sync();
          }, { threshold: 0.15 });
          this.observer.observe(this);
        } else {
          this.inViewport = true;
        }
        this.sync();
      }

      show(index, announce) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        const activeImage = this.slides[this.index].querySelector('img');
        if (activeImage) activeImage.loading = 'eager';
        if (announce && this.status) this.status.textContent = this.slides[this.index].getAttribute('aria-label');
      }

      manual(index) {
        this.paused = true;
        this.show(index, true);
        this.sync();
      }

      pause() {
        this.paused = true;
        this.sync();
      }

      sync() {
        clearTimeout(this.timer);
        if (this.pauseButton) {
          this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
          this.pauseButton.querySelector('[data-play-icon]').hidden = !this.paused;
          this.pauseButton.querySelector('[data-pause-icon]').hidden = this.paused;
        }
        if (!this.autoplay || this.paused || this.hovering || !this.inViewport || !this.ready || document.hidden) return;
        this.timer = setTimeout(() => {
          this.show(this.index + 1, false);
          this.sync();
        }, this.interval);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
